import React from 'react';
import PropTypes from 'prop-types';
import OffersV4OfferCard from './OffersV4OfferCard';

const OffersV4CardList = ({ offers, guidanceTags, selectedOfferId, onSelect }) => (
    <div className="offers-v4-offer-cards">
        {offers.map(offer => (
            <OffersV4OfferCard
                key={offer.id}
                offer={offer}
                onSelect={onSelect}
                guidanceTag={guidanceTags[offer.id]}
                isSelected={selectedOfferId === offer.id}
            />
        ))}
    </div>
);

OffersV4CardList.propTypes = {
    offers: PropTypes.array.isRequired,
    guidanceTags: PropTypes.object.isRequired,
    selectedOfferId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
};

export default OffersV4CardList;
